import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';

import {
  scrapeRestaurantInfo,
  updateRestaurantInfo,
} from '../../actions/restaurantsInfo/RestaurantsInfoActions';
import RestaurantCardCont from './RestaurantCardCont';
import { IAppStore } from '../../types/IAppStore';
import { IAppActions } from '../../types/IAppActions';
import { IDispatchProps, IStateProps } from './IRestaurantCard';

function mapStateToProps(state: IAppStore): IStateProps {
  return {
    currentRestaurant: state.cabinet.currentRestaurant,
    scrapeInfoLoading: state.reservesSystemInfo.scrapeInfoLoading
  };
}

function mapDispatchToProps(dispatch: Dispatch<IAppActions>): IDispatchProps {
  return bindActionCreators({
    updateRestaurantInfo,
    scrapeRestaurantInfo,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantCardCont);
